"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Action() {
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.2
  });
  const {
    ref: paraRef,
    isVisible: paraVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.2
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="20252" id="call-to-action" className="bg-background text-foreground ![padding:50px_0px_176px_0px]">
      <div className="mx-auto max-w-[760px] px-5 md:px-8">
        <div className="flex flex-col items-center text-center">
          <div ref={eyebrowRef} className={`font-default text-xs font-medium uppercase tracking-[0.14em] text-muted-foreground transition-all duration-[520ms] ease-out ${eyebrowVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            Get in touch today
          </div>

          <div aria-hidden="true" className="mt-6 h-px w-24 bg-border" />

          <h2 ref={headingRef} className={`font-default mt-10 font-normal text-foreground transition-all duration-[520ms] ease-out [text-wrap:balance] ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          fontSize: "clamp(2.5rem, 4.4vw, 3.5rem)",
          lineHeight: 1.06,
          letterSpacing: "-0.02em",
          transitionDelay: headingVisible ? "80ms" : "0ms"
        }}>
            Ready to optimize your{" "}
            <em className="font-serif italic font-normal">operations</em>?
          </h2>

          <p ref={paraRef} className={`font-default mt-8 text-muted-foreground transition-all duration-[520ms] ease-out ${paraVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          fontSize: "clamp(1.0625rem, 1.15vw, 1.1875rem)",
          lineHeight: 1.55,
          letterSpacing: "-0.003em",
          transitionDelay: paraVisible ? "160ms" : "0ms"
        }}>
            Contact our expert team. We provide rapid support for all your industrial equipment needs.
          </p>

          <div ref={ctaRef} className={`mt-12 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-4 w-full sm:w-auto transition-all duration-[520ms] ease-out ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: ctaVisible ? "240ms" : "0ms"
        }}>
            <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90 h-[52px] px-7 rounded-lg font-semibold text-base w-full sm:w-auto transition-all duration-200 ease-out hover:-translate-y-px shadow-md">
              <Link to="/ContactUsPage">Request a quote</Link>
            </Button>

            <Button asChild variant="outline" className="bg-transparent border border-border text-foreground hover:bg-accent hover:text-accent-foreground h-[52px] px-7 rounded-lg font-semibold text-base w-full sm:w-auto transition-all duration-200 ease-out shadow-sm">
              
            </Button>
          </div>
        </div>
      </div>
    </section>;
}